export default __webpack_public_path__ + "static/media/windows-settings.651b7b6e.jpg";